import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { Flex } from '@marvelapp/ui';
var styleMap = {
    default: {
        bg: 'transparent',
        color: 'slate',
        hoverBg: 'snowDark',
    },
    selected: {
        bg: 'marvel',
        color: 'white',
        hoverBg: 'marvel',
    },
};
function SelectionOptionView(_a, ref) {
    var isSelected = _a.isSelected, children = _a.children, _b = _a.styleOverrides, styleOverrides = _b === void 0 ? {} : _b, props = __rest(_a, ["isSelected", "children", "styleOverrides"]);
    var styleKey = isSelected ? 'selected' : 'default';
    var colors = styleOverrides[styleKey] || styleMap[styleKey];
    return (React.createElement(Flex, __assign({ alignItems: "center", borderRadius: 1, height: 30, justifyContent: "flex-start", minHeight: 30, pl: 1, pr: 1, ref: ref, width: 1 }, colors, props),
        React.createElement(Flex, { alignItems: "center", flex: 1, overflow: "hidden" }, children)));
}
export var SelectionOption = forwardRef(SelectionOptionView);
